import React from 'react'
function PoweredBy(props) {
    const {hidden} = props;

    const style = hidden ? {opacity: 0 } : null
    return (
    <div id="power" style={style} className="w-100 d-flex align-items-center justify-content-around pb-4">
        <div className="d-flex flex-row align-items-center">
            <div className="mr-1">Powered by</div>
            <a target="_blank" href="https://sutra.fit" className="power-item" id='logo'>SUTRA</a>
        </div>
    </div>
    )
}

export default PoweredBy;